import React from "react";
import styles from "./Truncate.module.scss";
import classNames from "classnames";
import Text, { TextProps } from "../Text/Text";

interface TruncateProps extends TextProps {
  lines: number | undefined;
}

// Unlike react-truncate this component cannot know when it's truncated.
const Truncate = ({ lines, className, ...others }: TruncateProps) => (
  <Text
    className={classNames(
      className,
      styles.root,
      lines ? styles[`lines${lines}`] : undefined
    )}
    {...others}
  />
);

export default Truncate;
